import React, { PureComponent } from 'react';
import { SofaButton } from '@sofology/sofologycomponents';
import { Grid } from '@material-ui/core';

import './AddressView.scss';

import { AddressModel } from 'models';

interface OwnProps {
    address: AddressModel;
    onEditClick?: () => void;
    readonly?: boolean;
}

export class AddressView extends PureComponent<OwnProps> {
    handleEditClick = () => {
        if (!this.props.readonly) {
            this.props.onEditClick!();
        }
    };

    render(): JSX.Element {
        return (
            <div className='address-view'>
                <Grid container>
                    <Grid item xs={9} sm={10}>
                        {this.renderAddress()}
                    </Grid>
                    <Grid item xs={3} sm={2}>
                        {!this.props.readonly && this.renderEditButton()}
                    </Grid>
                </Grid>
            </div>
        );
    }

    // eslint-disable-next-line sonarjs/cognitive-complexity
    renderAddress(): JSX.Element {
        // address format was cloned from old system
        // it looks complicated due to differences in addresses format in different api
        // and because there is no documentation for such api

        const { flat, building, number, street, town, county, postcode } = { ...this.props.address, postcode: this.props.address.postcode?.code };

        return (
            <div className='address-view__address'>
                <div>{flat && !this.isStreetIncludesAddressPart(street, flat) && flat}</div>
                <div>{building && !this.isStreetIncludesAddressPart(street, building) && building}</div>
                {this.isStreetIncludesAddressPart(street, number)
                    ? <div>{street}</div>
                    : <div>
                        {
                            (building && number && building.trim() !== number.trim()) || (!building || !number)
                                ? (number ? number + ' ' : '') + (street ? street : '')
                                : (street ? street : '')
                        }
                    </div>
                }
                <div>{town && (town + ' ')}{county}</div>
                <div>{postcode}</div>
            </div>
        );
    }

    renderEditButton(): JSX.Element {
        const editButtonText = <>Edit <i className='sa sa-pencil-square-o'></i></>;

        return <SofaButton
            text={editButtonText}
            variant='small'
            onClick={this.handleEditClick}
        />;
    }

    isStreetIncludesAddressPart(street?: string | null, part?: string | null): boolean {
        return Boolean(street && part && street.includes(part));
    }
}